import React, { memo, useEffect, useState } from "react";
import { AppConstant } from "const";

const CircleLoading = () => {
  const [loading, setLoading] = useState({ openRequest: 0, closeRequest: 0 });
  const isOpen = loading.openRequest !== loading.closeRequest;

  const handleOpenRequest = () => {
    setLoading(currentState => ({
      ...currentState,
      openRequest: currentState.openRequest + 1,
    }));
  };

  const handleCloseRequest = () => {
    if (loading.openRequest > loading.closeRequest) {
      const newCloseRequestNumber = loading.closeRequest + 1;
      setLoading(currentState => ({
        ...currentState,
        closeRequest:
          newCloseRequestNumber > currentState.openRequest ? currentState.openRequest : newCloseRequestNumber,
      }));
    }
  };

  const handleLoading = event => {
    const open = Boolean(event.detail && event.detail === true);
    if (open) handleOpenRequest();
    else handleCloseRequest();
  };

  useEffect(() => {
    window.addEventListener(AppConstant.CUSTOM_EVENTS.openCircleLoading, handleLoading);
    return () => window.removeEventListener(AppConstant.CUSTOM_EVENTS.openCircleLoading, handleLoading);
  });

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        background: "transparent",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <div className="progress w-100" style={{ height: "4px", borderRadius: 0 }}>
        <div
          className="progress-bar progress-bar-indeterminate"
          style={{ width: "100%" }}
        ></div>
      </div>
    </div>
  );
};

export default memo(CircleLoading);
